import * as React from "react"
import { Button, type ButtonProps } from "./button"
import { cn } from "~/lib/utils"

export interface ToggleButtonProps extends Omit<ButtonProps, "className"> {
  selected?: boolean
  defaultSelected?: boolean
  onSelectedChange?: (selected: boolean) => void
  className?: string
}

const ToggleButton = React.forwardRef<HTMLButtonElement, ToggleButtonProps>(
  ({ selected: selectedProp, defaultSelected = false, onSelectedChange, className, ...props }, ref) => {
    const [internalSelected, setInternalSelected] = React.useState(defaultSelected)
    const isControlled = selectedProp !== undefined
    const selected = isControlled ? selectedProp : internalSelected

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (!isControlled) {
        setInternalSelected(!selected)
      }
      onSelectedChange?.(!selected)
      props.onClick?.(e)
    }

    return (
      <Button
        ref={ref}
        {...props}
        className={cn(selected && "h-button--selected", className)}
        onClick={handleClick}
        aria-pressed={selected}
      />
    )
  },
)
ToggleButton.displayName = "ToggleButton"

export { ToggleButton }
